export const saveState = (state) => {
  try {
    console.log('saving state to localstorage');
    const serializedState = JSON.stringify(state);
    localStorage.setItem('userSchoolState', serializedState);
  } catch {
    // ignore write errors
  }
};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('userSchoolState');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (_err) {
    return undefined;
  }
};
